import React, { Component } from 'react';

//componentes
import CxCCli from './cxcCli'

class Index extends Component {

    render(){
        return(
            <div>
                <CxCCli />
            </div>
        );
    }

}
export default Index;